<template>
  <v-card raised class="c-main-shadow">
    <v-card-title primary-title class="c-content">
      <v-subheader class="w100 c-subheader">
        <div class="c-back">
          <v-tooltip right>
            <v-btn slot="activator" flat icon color="clr-back" :active-class="''" @click="backUrl"
              ><v-icon>chevron_left</v-icon></v-btn
            >
            <span>{{ $T('post.arrow.back') }}</span>
          </v-tooltip>
        </div>
        <div class="c-header">{{ getTitle }}</div>
        <v-spacer></v-spacer>
        <div v-if="!isFriend && !leTbS && showCommunity" class="c-genre">
          <div>{{ genre }} / {{ subgenre }}</div>
          <div><v-icon size="19">location_on</v-icon>{{ area }}</div>
        </div>
      </v-subheader>
      <v-container grid-list-lg text-xs-left>
        <v-layout column wrap>
          <v-flex v-if="showCommunity">
            <v-flex v-if="!isOpenInvitation" class="c-msg c-inv-msg">{{
              this.isFriend ? $T('page.member.invite.friend.msg') : $T('page.member.invite.msg')
            }}</v-flex>
            <div class="c-flex c">
              <div class="c-cover-120 c-img-cvr le-tbs-hide">
                <c-img :src="'/cover/invite/' + type + '/' + code" />
              </div>
              <div class="c-contents s">
                <div class="c-cname">{{ communityName }}</div>
                <div class="c-cover-120 c-img-cvr le-tbs-show">
                  <c-img :src="'/cover/invite/' + type + '/' + code" />
                </div>

                <template v-if="!isFriend">
                  <template v-if="explain">
                    <v-btn class="c-show-btn" flat color="clr-btn" @click="showExplain = !showExplain">
                      <span v-if="!showExplain">{{ $T('common.show_detail') }}</span
                      ><span v-if="showExplain">{{ $T('common.hide_detail') }}</span>
                    </v-btn>
                    <transition name="top">
                      <div v-show="showExplain" class="c-explain c-wiki" v-html="formatExplain(explain)"></div>
                    </transition>
                  </template>

                  <div class="c-condition nopadding">
                    <div class="c-ttl">{{ $T('page.community.member.relation') }}</div>
                    <div class="c-cond-content">
                      <span class="c-val c-head">
                        {{ publicityMember ? $T('param.there') : $T('param.none') }}
                      </span>
                    </div>
                  </div>
                  <div class="c-condition" v-if="condition">
                    <div class="c-ttl">{{ $T('attributes.rule_subscription') }}</div>
                    <div class="c-cond-content">
                      <template v-if="getGenderCondition">
                        <span class="c-attr">{{ $T('attributes.rule_gender') }} : </span
                        ><span class="c-val">{{ getGenderCondition }}</span>
                      </template>
                      <template v-if="getAgeCondition">
                        <span class="c-attr">{{ $T('attributes.rule_age') }} : </span
                        ><span class="c-val">{{ getAgeCondition }}</span>
                      </template>
                    </div>
                  </div>
                  <div class="c-genre le-tbs-show">
                    <div><v-icon class="area" size="16">location_on</v-icon>{{ area }}</div>
                    <div class="genre">{{ genre }} / {{ subgenre }}</div>
                  </div>
                </template>
              </div>
            </div>
          </v-flex>

          <template v-if="getErr">
            <v-flex class="c-err-title  clr-danger--text">{{ getErr.t }}</v-flex>
            <v-flex class="c-err-sub">{{ getErr.m }}</v-flex>
          </template>

          <template v-else-if="this.errType === 0">
            <v-flex v-if="!isOpenInvitation" class="c-expire">
              <div class="le-tbs-show">
                <span class="c-weak">{{ $T('expire_date') }}</span>
              </div>
              <div>
                <span class="c-weak le-tbs-hide">{{ $T('expire_date') }}</span
                ><span class="c-strong">{{ unixToMin(expired) }}</span>
              </div>
            </v-flex>
            <div v-if="!isFriend" class="c-input-area">
              <v-flex>
                <v-text-field
                  data-vv-name="profile"
                  data-vv-validate-on="blur"
                  ref="input_profile"
                  :label="$T('attributes.profile')"
                  v-model="profileName"
                  color="clr-primary"
                  counter="50"
                  v-validate="'required|max:50'"
                  :error-messages="getMessage('profile')"
                  required
                  autofocus
                  :disabled="loadingAccept || loadingDeny || complete"
                ></v-text-field>
              </v-flex>
              <v-flex class="jc">
                <div class="c-select-cover">
                  <select-cover :cid="communityId" type="profile" ref="cover" :coverPath="profileCover" />
                </div>
              </v-flex>
            </div>
          </template>
        </v-layout>
      </v-container>
    </v-card-title>

    <v-card-actions v-if="getErr" class="c-action">
      <v-spacer></v-spacer>
      <v-btn flat color="clr-primary" v-if="isOpenInvitation" @click="backUrl" :disabled="complete || loadingAccept">{{
        $T('button.back')
      }}</v-btn>
      <v-btn flat color="clr-primary" v-else :to="{ name: 'topHome', params: { id: selectedCommunity.id } }">{{
        $T('page.intro.link')
      }}</v-btn>
      <v-spacer></v-spacer>
    </v-card-actions>

    <v-card-actions v-else-if="this.errType === 0" class="c-action">
      <v-spacer></v-spacer>
      <v-btn
        round
        large
        @click="acceptInvitation"
        color="clr-primary"
        :disabled="complete || loadingDeny || (!isFriend && hasError())"
        :loading="loadingAccept"
        >{{ isFriend ? $T('page.member.invite.friend.button') : $T('page.member.invite.accept.button') }}</v-btn
      >
      <template v-if="!isOpenInvitation">
        <v-btn
          flat
          color="clr-primary"
          class="c-btn-no"
          v-if="type == 'd'"
          :to="{ name: 'topHome', params: { id: selectedCommunity.id } }"
          :disabled="complete || loadingAccept"
          >{{ isFriend ? $T('page.member.invite.skip.button_friend') : $T('page.member.invite.skip.button') }}</v-btn
        >
        <v-btn
          @click="refuseInvitation"
          class="c-deny-btn"
          flat
          color="clr-danger"
          v-else
          :disabled="complete || loadingAccept"
          :loading="loadingDeny"
          >{{ $T('page.member.invite.deny.button') }}</v-btn
        >
      </template>
      <v-spacer></v-spacer>
    </v-card-actions>

    <msg-dialog minWidth="600px" maxWidth="600px" :persistent="true" ref="invite_msg_dialog" @close="onMsgClosed" />
  </v-card>
</template>

<script>
import { COMMIN } from '../../constant';
import UTILS from '../../utils/utils';
import {
  getInviteLinkInfo,
  acceptInviteLink,
  acceptInviteFriendLink,
  refuseInviteLink,
} from '../../api/communityMember';

import selectCover from '../common/SelectCover.vue';

export default {
  data() {
    return {
      type: this.$route.params.type || 'd',
      code: this.$route.params.code,
      expired: null,
      errType: null,
      communityId: null,
      communityName: null,
      explain: null,
      publicityMember: null,
      condition: null,
      genre: null,
      subgenre: null,
      area: null,
      profileName: null,
      profileCover: null,
      errTitle: null,
      errMsg: null,
      loadingAccept: false,
      loadingDeny: false,
      complete: false,
      apiErrors: {},
      showExplain: false,
      isFriend: false,
    };
  },
  computed: {
    invitationCode() {
      return this.$route.params.code;
    },
    isOpenInvitation() {
      return this.$route.params.type == 'o';
    },
    getTitle() {
      return this.isFriend
        ? $T('page.member.invite.friend.title')
        : this.isOpenInvitation
        ? $T('page.member.invite.join.title')
        : $T('page.member.invite.to_community.title');
    },
    showCommunity() {
      return (
        this.errType == 0 ||
        this.errType == 5 ||
        this.errType == 6 ||
        this.errType == 7 ||
        this.errType == 10 ||
        this.errType == 90
      );
    },
    getErr() {
      if (!this.errType) return false;
      switch (this.errType) {
        case 1:
          return {
            t: $T('page.member.invite.err.invalid.title'),
            m: $T('page.member.invite.err.invalid.msg'),
          };
        case 2:
          return {
            t: $T('page.member.invite.err.disabled.title'),
            m: $T('page.member.invite.err.disabled.msg'),
          };
        case 3:
          return {
            t: $T('page.member.invite.err.timeout.title'),
            m: $T('page.member.invite.err.timeout.msg'),
          };
        case 4:
          return {
            t: $T('page.member.invite.err.used.title'),
            m: $T('page.member.invite.err.used.msg'),
          };
        case 5:
          if (this.isFriend) {
            return {
              t: $T('page.member.invite.err.registered.friend.title'),
              m: $T('page.member.invite.err.registered.friend.msg'),
            };
          } else {
            return {
              t: $T('page.member.invite.err.registered.title'),
              m: $T('page.member.invite.err.registered.msg'),
            };
          }
        case 6:
          if (this.isFriend) {
            return {
              t: $T('page.member.invite.err.entried.friend.title'),
              m: $T('page.member.invite.err.entried.friend.msg'),
            };
          } else {
            return {
              t: $T('page.member.invite.err.entried.title'),
              m: $T('page.member.invite.err.entried.msg'),
            };
          }
        case 7:
          return {
            t: $T('page.member.invite.err.no_condition.title'),
            m: $T('page.member.invite.err.no_condition.msg'),
          };
        case 10:
          return {
            t: $T('page.member.invite.err.member_limit.title'),
            m: $T('page.member.invite.err.member_limit.msg'),
          };
        case 11:
          return {
            t: $T('page.member.invite.err.friend_limit.title'),
            m: $T('page.member.invite.err.friend_limit.self'),
          };
        case 12:
          return {
            t: $T('page.member.invite.err.friend_limit.title'),
            m: $T('page.member.invite.err.friend_limit.other'),
          };
        case 90:
          return {
            t: $T('page.member.invite.err.self.title'),
            m: $T('page.member.invite.err.self.msg'),
          };
        case 99:
          if (this.isFriend) {
            return {
              t: $T('page.member.invite.err.banned.friend.title'),
              m: $T('page.member.invite.err.banned.friend.msg'),
            };
          } else {
            return {
              t: $T('page.member.invite.err.banned.title'),
              m: $T('page.member.invite.err.banned.msg'),
            };
          }
        case 100:
          if (this.isFriend) {
            return {
              t: $T('page.member.invite.err.dissolved.friend.title'),
              m: $T('page.member.invite.err.dissolved.friend.msg'),
            };
          } else {
            return {
              t: $T('page.member.invite.err.dissolved.title'),
              m: $T('page.member.invite.err.dissolved.msg'),
            };
          }
      }
      console.error('Unknown errType ' + this.errType);
      return {
        t: 'Unknown Error',
        m: 'Unknown Error',
      };
    },
    getGenderCondition() {
      if (!this.condition) return false;
      switch (this.condition.gender) {
        case 0:
          return false;
        case 1:
          return $T('params.gender.male');
        case 2:
          return $T('params.gender.female');
        case 3:
          return $T('params.gender.other');
      }
      console.error('Unknown gender condition ' + this.errType);
      return 'Unknown Gender Condition';
    },
    getAgeCondition() {
      if (!this.condition || (!this.condition.min_age && !this.condition.max_age)) return false;
      let min = this.condition.min_age ? this.condition.min_age : '';
      let max = this.condition.max_age ? this.condition.max_age : '';
      return $T('common.min_max.range', { min: min, max: max });
    },
  },
  created() {},
  components: {
    'select-cover': selectCover,
  },
  mounted() {
    UTILS.startLoading();
    var _this = this;
    getInviteLinkInfo(this.type, this.code)
      .then(function(response) {
        var isFriend = response.communityId == _this.$store.state.community.fcid;
        _this.expired = response.expired;
        _this.communityId = response.communityId;
        _this.communityName = response.communityName;
        _this.explain = response.explain;
        _this.publicityMember = response.publicity_member;
        _this.condition = response.condition;
        _this.genre = response.genre;
        _this.subgenre = response.subgenre;
        _this.area = response.area;
        _this.profileName = response.defaultProfileName;
        _this.profileCover = response.defaultProfileCoverPath;
        _this.errType = response.errType;
        _this.isFriend = isFriend;
        UTILS.stopLoading();
      })
      .catch(function(error) {
        console.error('error to check type and code.', error);
        _this.errTitle = null;
        _this.errMsg = null;
        _this.errType = 9;
        UTILS.stopLoading();
      });
  },
  methods: {
    backUrl() {
      let ref = document.referrer;
      if (ref) {
        let host = location.protocol + '//' + location.host + '/c/';
        if (ref.startsWith(host)) {
          history.back();
          return false;
        }
      }
      if (this.communityId) {
        location.href = '/c/' + this.userLang + '/' + this.communityId + '/';
      } else {
        location.href = '/';
      }
      return false;
    },
    hasError() {
      return !this.profileName || this.errors.items.length > 0;
    },
    getMessage(fieldName) {
      return this.apiErrors[fieldName] && this.apiErrors[fieldName][this.inputValue]
        ? this.apiErrors[fieldName][this.inputValue]
        : this.errors.collect(fieldName);
    },
    acceptInvitation() {
      if (this.isFriend) {
        var _this = this;
        acceptInviteFriendLink(_this.type, _this.code)
          .then(function(response) {
            _this.loadingAccept = false;
            if (response.errType == 0) {
              _this.complete = true;
              if (response.entryType == 1) {
                _this.$refs.invite_msg_dialog.open(
                  $T('page.member.invite.joined.friend.title'),
                  $T('page.member.invite.joined.friend.msg')
                );
                UTILS.updateStateCommunities(_this.$store, _this.$route, true, function() {});
              } else {
                _this.$refs.invite_msg_dialog.open(
                  $T('page.member.invite.entried.friend.title'),
                  $T('page.member.invite.entried.friend.msg')
                );
              }
            } else {
              _this.expired = response.expired;
              _this.communityId = response.communityId;
              _this.communityName = response.communityName;
              _this.errType = response.errType;
            }
          })
          .catch(function(error) {
            _this.loadingAccept = false;
            console.error(error);
          });
      } else {
        var data = new FormData();
        data.append('profile_name', this.profileName);
        data.append('profile_cover', this.$refs.cover.path);
        this.$refs.cover.appendNewCoversToForm(data, 'profile_files');
        this.$refs.cover.appendDeletedCoversToForm(data, 'profile_deleted');
        this.loadingAccept = true;
        var _this = this;
        this.$validator.validateAll().then(result => {
          if (result) {
            acceptInviteLink(_this.type, _this.code, data)
              .then(function(response) {
                _this.loadingAccept = false;
                if (response.errType == 0) {
                  _this.complete = true;
                  if (response.entryType == 1) {
                    _this.$refs.invite_msg_dialog.open(
                      $T('page.member.invite.joined.title'),
                      $T('page.member.invite.joined.msg')
                    );
                    UTILS.updateStateCommunities(_this.$store, _this.$route, true, function() {});
                  } else {
                    _this.$refs.invite_msg_dialog.open(
                      $T('page.member.invite.entried.title'),
                      $T('page.member.invite.entried.msg')
                    );
                  }
                } else {
                  _this.expired = response.expired;
                  _this.communityId = response.communityId;
                  _this.communityName = response.communityName;
                  _this.errType = response.errType;
                }
              })
              .catch(function(error) {
                _this.loadingAccept = false;
                console.error(error);
              });
          } else {
            _this.loadingAccept = false;
            console.warn('there is invalid values.');
          }
        });
      }
    },
    refuseInvitation() {
      this.loadingDeny = true;
      var _this = this;
      refuseInviteLink(this.type, this.code)
        .then(function(response) {
          _this.loadingDeny = false;
          if (response.errType == 0) {
            _this.complete = true;
            _this.$refs.invite_msg_dialog.open(
              $T('page.member.invite.denied.title'),
              $T('page.member.invite.denied.msg')
            );
          } else {
            _this.expired = response.expired;
            _this.errType = response.errType;
          }
        })
        .catch(function(error) {
          _this.loadingDeny = false;
          console.error(error);
        });
    },
    onMsgClosed() {
      this.$router.push({ name: 'topHome', params: { id: this.selectedCommunity.id } });
    },
    formatExplain(v) {
      return markdown(v);
    },
  },
};
</script>

<style scoped>
.container {
  padding: 16px !important;
}
.le-tbs .container {
  padding: 8px !important;
}
.le-tbs .container .flex {
  padding: 0;
}
.c-space {
  min-height: 480px;
}
.c-space-s {
  height: 10px;
}
.c-err-title {
  width: 100%;
  text-align: center;
  font-size: 20px;
}
.le-tbs .c-err-title {
  margin-top: 25px;
  margin-bottom: 10px;
}
.c-show-btn {
  margin-top: 12px;
}
.c-err-sub {
  width: 100%;
  text-align: center;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.54);
  word-break: break-all;
  word-wrap: break-word;
  white-space: pre-wrap;
}
.c-expire {
  text-align: center;
}
.le-tbs .c-expire {
  margin: 25px 0 0 0;
}
.c-weak {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.54);
  margin-right: 8px;
}
.le-tbs .c-weak {
  margin: 0;
}
.c-strong {
  font-size: 24px;
  font-weight: 600;
  color: #303030;
}
.v-subheader {
  height: 20px !important;
}
.c-cover-area {
  margin-top: 5px;
}
.c-cover-img {
  float: left;
  margin-left: 10px;
}
.c-cover-title {
  margin-top: 10px;
  color: rgba(0, 0, 0, 0.54);
}
.c-cover-btn {
  float: left;
  height: 80px;
  line-height: 80px;
  margin-left: 20px;
  vertical-align: middle;
}
.c-cname {
  font-size: 28px;
  font-weight: 600;
  margin: 0px 0px 5px 0;
  line-height: 1.2;
  white-space: pre-wrap;
  word-wrap: break-word;
  overflow-wrap: break-word;
}
.le-tbs .c-cname {
  margin-top: 0;
  font-size: 22px;
}
.c-explain {
  text-align: left;
  font-size: 15px;
  color: rgba(0, 0, 0, 0.92);
  overflow: hidden;
  margin: 15px 10px 20px 0;
}
.le-tbs .c-explain {
  margin: 10px 0 10px 0;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.92);
}
.c-inv-msg {
  padding: 0 0 20px 0 !important;
}
.le-tbs .c-inv-msg {
  margin: 0 0 15px 0;
  padding: 0 !important;
}
.c-input-area {
  padding: 20px 100px 0 100px;
}
.le-tbs .c-input-area {
  padding: 20px 8px 0 8px;
}

.c-condition {
  padding: 15px 10px 0 10px;
  text-align: left;
  flex-direction: column;
}
.c-condition .c-ttl {
  font-weight: 400;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.54);
}
.c-condition .c-cond-content {
  text-align: left;
  margin-left: 5px;
}
.c-condition .c-attr {
  margin-left: 10px;
  color: rgba(0, 0, 0, 0.72);
  font-size: 12px;
}
.c-condition .c-val {
  font-size: 16px;
  font-weight: 600;
}

.c-condition .c-val.c-head {
  margin-left: 10px;
}

.c-img-cvr {
  align-self: flex-start;
  margin-top: 8px;
}
.le-tbs .c-img-cvr {
  align-self: center;
  margin: 10px auto;
}
.c-contents {
  padding-left: 25px;
  width: calc(100% - 178px);
}
.le-tbs .c-contents {
  padding: 0;
}
.v-card__actions {
  margin-top: -8px;
  padding: 0 0 18px 0 !important;
}
.c-main-shadow {
  padding: 18px;
  border-color: #999 !important;
}
.le-tbs .c-main-shadow {
  padding: 0 16px 16px 16px;
  border: none;
}
.c-content {
  padding: 0;
}
.c-subheader {
  height: initial !important;
  padding: 0 24px 0 16px;
}
.le-tbs .c-subheader {
  padding: 0;
}
.c-back {
  margin-left: -14px;
}
.le-tbs .c-back {
  margin: 0 -5px 0 -20px;
}
.c-header {
  font-size: 14px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.54);
}
.le-tbs .c-header {
}
.c-genre {
  text-align: right;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.54);
}
.le-tbs .c-genre {
  padding: 25px 0 0 0;
  width: 100%;
  text-align: left;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.72);
}
.c-select-cover {
  width: 196px;
  margin: 15px auto 0 auto;
}
.c-action {
  margin-top: 18px;
  flex-direction: column;
}
.le-tbs .c-action {
  margin-top: 30px;
}
.c-btn-no {
  margin-top: 12px !important;
}
.c-deny-btn {
  margin-top: 20px;
}
</style>
